<script>
    const galleryImages = [
		{
			url: '/images/pool-1.jpg'
		},
		{
			url: '/images/restaurant1-1.jpg'
		},
		{
			url: '/images/grill-1.jpg'
		},
		{
			url: '/images/bar-1-1.jpg'
		},
		{
			url: '/images/room.jpg'
		},
		{
			url: '/images/lawn-1.jpg'
		},
		{
			url: '/images/camp-1.jpg'
		},
		{
			url: '/images/restaurant2-1.jpg'
		},
		{
			url: '/images/room-1.jpg'
		},
		{
			url: '/images/home_slider_1.jpg'
		},
		{
			url: '/images/home_slider_2.jpg'
		},
		{
			url: '/images/home_slider_3.jpg'
		},
		{
			url: '/images/home_slider_4.jpg'
		},
		{
			url: '/images/home_slider_3.jpg'
		},
		{
			url: '/images/rsz_hall_2b.jpg'
		}
	];
</script>

<div id="gallery-slider" class="carousel slide" data-bs-ride="carousel">
	<div class="carousel-inner">
		{#each galleryImages as item, i}
			<div class="carousel-item {i == 0 ? 'active' : ''}">
				<img src={item.url} class="d-block w-100" alt="...">
			</div>
		{/each}
	</div>
	<button class="carousel-control-prev" type="button" data-bs-target="#gallery-slider" data-bs-slide="prev">
	  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
	  <span class="visually-hidden">Previous</span>
	</button>
	<button class="carousel-control-next" type="button" data-bs-target="#gallery-slider" data-bs-slide="next">
	  <span class="carousel-control-next-icon" aria-hidden="true"></span>
	  <span class="visually-hidden">Next</span>
	</button>
</div>